import React from "react";
import {View, Text, StyleSheet, TouchableOpacity} from "react-native";
import {globalFontStyle, globalStyle} from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import RupeeVal from "../../../commonComponents/RupeeVal";
import {
  globalConfigurableData,
  GlobalScreens,
} from "../../../utils/globalConstant";
import {useNavigation} from "@react-navigation/native";
import {isMobile} from "../../../utils/commonMethods";
import FormTextLabel from "../../../commonComponents/FormTextLabel";

const TxnCard = ({transaction, onTransactionClick}) => {
  let navigation = useNavigation();

  return (
    <View>
      <TouchableOpacity
        onPress={() => {
          if (isMobile()) {
            navigation.navigate("WalletStack", {
              screen: "TransactionScreen",
              params: {
                transaction: transaction?.transactionData,
                typeTxn: transaction?.type,
              },
            });
          } else {
            onTransactionClick?.(transaction);
          }
        }}>
        <View>
          <View style={styles.rowStyle}>
            <View style={styles.textContainer}>
              <Text
                style={[
                  styles.r2Col1,
                  {color: globalConfigurableData.primaryTextColor1},
                ]}
                numberOfLines={1}
                ellipsizeMode="tail">
                {transaction?.transactionData?.subtitle}
              </Text>
              <Text style={[styles.r1Col1]} numberOfLines={1}>
                {transaction?.transactionData?.title}
              </Text>
            </View>
            <View style={styles.amountContainer}>
              <RupeeVal
                customStyle={[
                  styles.r2Col2,
                  {
                    color:
                      transaction?.type === 'DEBIT'
                        ? '#e90000'
                        : '#00AA51',
                  },
                ]}
                rupeeVal={transaction?.transactionData?.amount || 0}
              />
              {transaction?.transactionData?.status && (
                <FormTextLabel
                  labelStyles={[
                    styles.r1Col1,
                    {
                      color:
                        transaction?.status === "in process"
                          ? "#E8B600"
                          : transaction?.status === "Failed"
                          ? "#A8200D"
                          : "#00AA51",
                    },
                  ]}
                  label={transaction?.transactionData?.status}
                />
              )}
            </View>
          </View>
          <View style={styles.txnPartition} />
        </View>
      </TouchableOpacity>
    </View>
  );
};

export default TxnCard;

const styles = StyleSheet.create({
  rowStyle: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: 14,
  },
  textContainer: {
    flex: 1,
    paddingRight: 16,
    justifyContent: 'center',
  },
  amountContainer: {
    alignItems: 'flex-end',
    minWidth: 90,
    justifyContent: 'center',
  },
  r1Col1: {
    ...globalFontStyle.appFontSmallText,
    color: globalConfigurableData.secondaryTextColor1,
  },
  r2Col1: {
    ...globalFontStyle.appFontSubText,
    color: globalConfigurableData.primaryTextColor1,
    marginBottom: 4,
  },
  r2Col2: {
    ...globalFontStyle.appFontSubText,
    marginBottom: 4,
  },
  txnPartition: {
    borderBottomWidth: 0.75,
    borderBottomColor: globalConfigurableData.borderColor,
  },
});
